import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BusyService {
  loading = false;
  busyRequestCount = 0;
  loading$ = new BehaviorSubject<boolean>(this.loading);

  busy() {
    this.busyRequestCount++;
    this.loading = true;
    this.loading$.next(this.loading);
  }

  idle() {
    this.busyRequestCount--;
    if (this.busyRequestCount <= 0) {
      this.busyRequestCount = 0;
      this.loading = false;
      this.loading$.next(this.loading);
    }
  }
}
